import React, { Fragment, ReactElement } from "react";
import classnames from 'classnames';

let Styles: any;

/* try {
    Styles = require('./CardContainer_' + process.env.REACT_APP_CODE_TENANT + '.module.scss');
}
catch { */
    Styles = require('./CardContainer.module.scss');
/* } */

interface CardContainerProps {
    form?: boolean,
    children: ReactElement,
    className: string,
    colorBackground?: string,// primary, secondary
}
const CardContainer: React.FC<CardContainerProps> = (props: CardContainerProps) => {
    const { form, children, className, colorBackground } = props;
    let compoundClassName: string = Styles.shadowRounded ;
    if(form){
        compoundClassName = Styles.shadowRoundedPrincipalForm;
    }
    if (colorBackground !== null &&  colorBackground=="primary")
        compoundClassName = Styles.shadowRoundedPlate;
    return (
        <div className="row justify-content-center">
            <div className={className}>
                <div className={ classnames(compoundClassName, "card")}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default CardContainer;